import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MesDossiersComponent } from './mes-dossiers/mes-dossiers.component';
import { MonHistoriqueDossierComponent } from './mon-historique-dossier/mon-historique-dossier.component';
import { MesTachesEnCoursComponent } from './mes-taches-en-cours/mes-taches-en-cours.component';



const routes: Routes = [
  
  {
    path: '',
    data: {breadcrumb: 'Workflow'},
    children: [
        {
            path:'',
            redirectTo: 'mes-dossiers',
            pathMatch: 'full' 
        },
        {
            path: 'mes-dossiers',
            component: MesDossiersComponent,
            data: {breadcrumb: 'Activité'},
        },
        {
            path: 'mes-taches-en-cours',
            component: MesTachesEnCoursComponent,
            data: {breadcrumb: 'Activité'},
        },
        {
            path: 'mon-historique-dossier',
            component: MonHistoriqueDossierComponent,
            data: {breadcrumb: 'Activité'},
        },
    ]
  }
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MonPortefeuilleRoutingModule { }
